export { default } from './EmprestimoGarantiaCarroCondicoes';
